import { colors } from 'styles/colors'

export const theme = {
  colors
}
